module.exports = __webpack_public_path__ + "img/9788959523078.c7b9a084.jpg";